var _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatMessagesBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.849 16.396C20.579 15.096 21 13.598 21 12C21 7.029 16.971 3 12 3C7.029 3 3 7.029 3 12C3 16.971 7.029 21 12 21C13.598 21 15.096 20.579 16.396 19.849L21 21L19.849 16.396Z",
    stroke: "#282828",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8228 12.3235C11.9208 12.2255 12.0788 12.2255 12.1768 12.3235C12.2748 12.4215 12.2748 12.5795 12.1768 12.6775C12.0788 12.7755 11.9208 12.7755 11.8228 12.6775C11.7258 12.5795 11.7258 12.4215 11.8228 12.3235ZM7.82275 12.3235C7.92075 12.2255 8.07875 12.2255 8.17675 12.3235C8.27475 12.4215 8.27475 12.5795 8.17675 12.6775C8.07875 12.7755 7.92075 12.7755 7.82275 12.6775C7.72575 12.5795 7.72575 12.4215 7.82275 12.3235ZM15.8228 12.3235C15.9208 12.2255 16.0788 12.2255 16.1768 12.3235C16.2748 12.4215 16.2748 12.5795 16.1768 12.6775C16.0788 12.7755 15.9208 12.7755 15.8228 12.6775C15.7258 12.5795 15.7258 12.4215 15.8228 12.3235Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12.5,
    r: 1,
    fill: "#282828"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 1,
    fill: "#282828"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12.5,
    r: 1,
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessagesBlack);
export default __webpack_public_path__ + "static/media/chat_messages_black.cad42841b493e9384c24520887f77987.svg";
export { ForwardRef as ReactComponent };